<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold">مغایرت گیری</h5>
        <div style="flex:1"></div>
        <Back url="/admin/contradictions" />
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <form>
              <b-form-group label="انتخاب انبار">
                <select
                  class="form-control d-flex col-md-3"
                  v-model="fromStore"
                  @change="clearVarieties"
                >
                  <option
                    v-for="agency in stores"
                    :value="{ id: agency.id, name: agency.label }"
                    >{{ agency.label }}</option
                  >
                </select>
              </b-form-group>
              <b-form-group label="انتخاب محصول">
                <div class="d-flex col-md-6" style="gap: 0.5rem">
                  <b-form-input
                    autocomplete="off"
                    ref="productSku"
                    v-model="productSku"
                    :disabled="disabled"
                    @keypress.prevent.enter="requestProduct"
                    type="text"
                  />
                  <!-- <div class="d-flex mr-3" style="gap: 0.6rem">
                    <label for="refund_checkbox">مرجوعی</label>
                    <b-form-checkbox
                      id="refund_checkbox"
                      type="checkbox"
                      :disabled="disabled"
                      v-model="refund"
                    />
                  </div> -->
                </div>
              </b-form-group>
              <b-form-group label="جستجوی محصول" class="mb-5">
                <ProductSearch
                  ref="productSearch"
                  :store="{ id: fromStore ? fromStore.id : '' }"
                  :selectable="true"
                  class="row mb-5"
                  :show-label="false"
                  @selectVariety="selectVariety"
                />
              </b-form-group>
            </form>
          </div>
        </div>
        <div v-if="varieties && varieties.length" class="row mt-2">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شناسه</th>
                <th>بارکد</th>
                <th>محصول</th>
                <th>انبار</th>
                <th>تعداد درخواستی</th>
                <th>حذف</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(variety, index) in varieties" :key="index">
                <td>
                  <span>{{ index + 1 }}</span>
                </td>
                <td>
                  <span>{{ variety.id }}</span>
                </td>
                <td>
                  <span>{{ variety.barcode }}</span>
                </td>
                <td>
                  <span style="width: 300px">
                    <span style="line-height: 2">{{
                      variety.product.title
                    }}</span>
                    <span v-if="variety.color || variety.attributes != ''">
                      <span> | </span>
                      <span v-if="variety.color">
                        رنگ : {{ variety.color.name }}
                        {{ variety.attributes != "" ? " | " : "" }}
                      </span>
                      <span v-if="variety.attributes != ''">
                        <span
                          v-for="(attr, index) in variety.attributes"
                          :key="index"
                        >
                          {{ attr.label + ": " + attr.pivot.value }}
                          {{
                            index != variety.attributes.length - 1 ? " | " : ""
                          }}
                        </span>
                      </span>
                    </span>
                  </span>
                </td>

                <td>{{ fromStore.name }}</td>
                <td>
                  <input
                    type="number"
                    min="1"
                    class="form-control form-control-sm"
                    v-model.number="variety.requestedQuantity"
                    placeholder="تعداد"
                  />
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-icon btn-danger text-white"
                    @click="deleteItem(index)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer" v-if="varieties.length > 0">
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="btn btn-success text-right item-right"
            :disabled="isButtonDisabled"
            @click="submitData"
          >
            ارسال
          </button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ContradictionsCreateImpl from "@@/core/pages/Contradictions/contradictionCreateImpl";
export default {
  extends: ContradictionsCreateImpl,
};
</script>
<style>
.search #product-select {
  width: 100% !important;
  max-width: 100% !important;
  margin-bottom: 0 !important;
}
.search .form-group {
  width: 100% !important;
  max-width: 100% !important;
  margin-top: 10px !important;
}
</style>
